import React from 'react';
import { IconButton, IconPlaySolid, IconPauseLine } from '@instructure/ui';
import { usePlayerStore, getStore } from '../../../stores/StoreContext';
const PlayPause = () => {
  const PlayerStore = getStore('playerStore');

  {
    /* Listen to any changes in the stores... */
  }
  const playing = usePlayerStore((state) => state.playing);
  const isLive = usePlayerStore((state) => state.isLive);

  return (
    <>
      {!isLive && (
        <>
          {playing ? (
            <IconButton
              as="span"
              size="small"
              style={{ zIndex: '99999' }}
              screenReaderLabel="Pause Playback"
              onClick={() => PlayerStore.setPlaying(false)}
            >
              <IconPauseLine size="x-small" />
            </IconButton>
          ) : (
            <IconButton
              as="span"
              size="small"
              style={{ zIndex: '99999' }}
              screenReaderLabel="Start Playback"
              onClick={() => PlayerStore.setPlaying(true)}
            >
              <IconPlaySolid size="x-small" />
            </IconButton>
          )}
        </>
      )}
    </>
  );
};

export default PlayPause;
